import { SelectChangeEvent } from '@mui/material/Select'
import React, { useState } from 'react'
import LanguageCurrencyDropdown, { CountryOption, LanguageCurrencyDropdownProps } from './LanguageCurrencyDropdown'
import { setCookie } from '@/src/utils/browser'
import {
    getCountryOptions,
    detectCurrentCountry as detectCountry
} from '@/src/utils/countryOptions'

interface LanguageCurrencyDropdownLogicProps {
    selectedLanguage: LanguageCurrencyDropdownProps['selectedLanguage']
    selectedCurrency: LanguageCurrencyDropdownProps['selectedCurrency']
    languageOptions: LanguageCurrencyDropdownProps['languageOptions']
    currencyOptions: LanguageCurrencyDropdownProps['currencyOptions']
    onLanguageSelect: LanguageCurrencyDropdownProps['onLanguageSelect']
    onCurrencySelect: LanguageCurrencyDropdownProps['onCurrencySelect']
    t: LanguageCurrencyDropdownProps['t']
    tCurrency: LanguageCurrencyDropdownProps['tCurrency']
    isOffersPage?: boolean
    variant?: 'flyin' | 'cleartrip'
}

const LanguageCurrencyDropdownLogic: React.FC<LanguageCurrencyDropdownLogicProps> = props => {
    const variant = props.variant ?? 'flyin'
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [countrySelectOpen, setCountrySelectOpen] = useState(false)
    const open = Boolean(anchorEl)
    const isQA =
        typeof window !== 'undefined' &&
        (window.location.hostname.includes('me') ||
            window.location.hostname.includes('qa2') ||
            window.location.hostname.startsWith('qa.'))
    const countryOptions = getCountryOptions(props.t, variant)

    const getCurrentCountry = (): CountryOption => {
        if (typeof window === 'undefined') return countryOptions[0]

        const currentHostname = window.location.hostname
        return detectCountry(currentHostname, countryOptions, isQA, variant)
    }

    const [selectedCountry, setSelectedCountry] = useState<CountryOption>(() => {
        const country = getCurrentCountry()
        return country || countryOptions[0]
    })

    const handleCountryChange = (event: SelectChangeEvent) => {
        const countryCode = event.target.value
        const newCountry = countryOptions.find(c => c.code === countryCode) || countryOptions[0]

        if (newCountry.code === selectedCountry.code) return

        setSelectedCountry(newCountry)
        if (variant === 'flyin') {
            setCookie('cc', newCountry.code, undefined, '.flyin.com')
        }
        const targetDomain = isQA ? newCountry.qaDomain : newCountry.domain
        const currentUrl = new URL(window.location.href)
        currentUrl.hostname = targetDomain
        currentUrl.protocol = window.location.protocol
        window.location.href = currentUrl.toString()
    }

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleCountrySelectOpen = () => setCountrySelectOpen(true)
    const handleCountrySelectClose = () => setCountrySelectOpen(false)

    return (
        <LanguageCurrencyDropdown
            {...props}
            selectedCountry={selectedCountry}
            countryOptions={countryOptions}
            countrySelectOpen={countrySelectOpen}
            onCountrySelectOpen={handleCountrySelectOpen}
            onCountrySelectClose={handleCountrySelectClose}
            onCountryChange={handleCountryChange}
            onCountrySelect={() => {}}
            open={open}
            anchorEl={anchorEl}
            onOpen={handleOpen}
            onClose={handleClose}
            isOffersPage={props.isOffersPage}
        />
    )
}

export default LanguageCurrencyDropdownLogic
